class ChainTypes {
    static Invalid = 0;
    static Segue = 1;
    static AutoPost = 2;
    static Stop = 3;
    static LinkSong = 4;
}

export default ChainTypes;